import { render, staticRenderFns } from "./Dirords.vue?vue&type=template&id=435467da&"
import script from "./Dirords.vue?vue&type=script&lang=js&"
export * from "./Dirords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports